import { ModalLayout } from '@/layouts/ModalLayout';
import { ProfileAvatar } from '../common/ProfileAvatar';
import { TabItem, Tabs } from '../ui/Tabs';
import { RootState } from '@/store';
import { useSelector } from 'react-redux';
import { Button } from '../ui/button';
import useAvatarHook from '@/hooks/useAvatarHook';
import Images from '../common/Images';
interface profileAvatarModalProps {
  isProfileModalOpen: boolean;
  className?: string;
  onClose: () => void;
}
const ProfileAndAvatarModal = ({
  isProfileModalOpen,
  onClose,
  className,
}: profileAvatarModalProps) => {
  const {
    handleCloseModal,
    handleFileSelect,
    handleSave,
    activeTab,
    selectedFile,
    setSelectedAvatar,
    setSelectedFile,
    setPreviewImage,
    selectedAvatar,
    avatarData,
    previewImage,
    setActiveTab,
  } = useAvatarHook(onClose);
  const tabList: TabItem<number>[] = [
    {
      id: 1,
      label: 'Upload Photo',
    },
    {
      id: 2,
      label: 'Choose Avatar',
    },
  ];
  const user = useSelector((s: RootState) => s.user.profile);
  return (
    <ModalLayout open={isProfileModalOpen} onClose={handleCloseModal} className="max-w-md">
      <div className="p-5 max-h-[80vh] overflow-y-auto">
        <h2 className="text-lg font-semibold text-center">Update Profile Picture</h2>

        <div className="mt-5 flex justify-center">
          <ProfileAvatar
            size="lg"
            image={previewImage || user?.profileImage || ''}
            username={user?.username}
            fallbackSrc="/matches/nodata/fallbackprofile.webp"
          />
        </div>

        <Tabs tabs={tabList} activeTab={activeTab} onTabChange={setActiveTab} className="mt-6" />

        {activeTab === 1 && (
          <div className="mt-5">
            <label htmlFor="profile-upload" className="block cursor-pointer">
              <div className="w-full rounded-xl border border-dashed border-orange-500 p-6 text-center">
                Upload Photo
              </div>
            </label>

            <input
              id="profile-upload"
              type="file"
              accept="image/*"
              className="hidden"
              onChange={handleFileSelect}
            />

            {selectedFile && (
              <p className="mt-3 text-center text-sm text-green-500">{selectedFile.name}</p>
            )}
          </div>
        )}

        {activeTab === 2 && (
          <div className="mt-5 grid grid-cols-3 gap-3">
            {avatarData?.data?.map((avatar) => (
              <button
                key={avatar.id}
                type="button"
                onClick={() => {
                  setSelectedAvatar(avatar);
                  setSelectedFile(null);
                  setPreviewImage(avatar.avatarUrl);
                }}
                className={`relative rounded-xl border p-2 transition-all ${
                  selectedAvatar?.id === avatar.id
                    ? 'border-orange-500 ring-2 ring-orange-500'
                    : 'border-white/10'
                }`}
              >
                <Images
                  src={avatar.avatarUrl}
                  alt={avatar.name}
                  className="h-24 w-full rounded-lg object-cover"
                />

                {selectedAvatar?.id === avatar.id && (
                  <div className="absolute right-2 top-2 flex h-5 w-5 items-center justify-center rounded-full bg-orange-500 text-xs text-white">
                    ✓
                  </div>
                )}
              </button>
            ))}
          </div>
        )}

        <Button
          className="mt-6 w-full"
          disabled={!selectedAvatar && !selectedFile}
          //   loading={isUpdateLoading}
          onClick={handleSave}
        >
          Save Profile Picture
        </Button>
      </div>
    </ModalLayout>
  );
};

export default ProfileAndAvatarModal;
